"use strict";

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx("span", {
    className: "m-tabs_tiles--center-helper"
});

var _ref2 = _jsx("span", {
    className: "m-tabs_tiles--center-helper"
});

var ClickableImage = _react2["default"].createClass({
    displayName: "ClickableImage",


    propTypes: {
        imgSourceActive: _react2["default"].PropTypes.string.isRequired,
        imgSourceInactive: _react2["default"].PropTypes.string.isRequired,
        imgSourceActiveHeight: _react2["default"].PropTypes.number,
        imgSourceActiveWidth: _react2["default"].PropTypes.number,
        imgSourceInactiveHeight: _react2["default"].PropTypes.number,
        imgSourceInactiveWidth: _react2["default"].PropTypes.number,
        imgText: _react2["default"].PropTypes.string,
        isActive: _react2["default"].PropTypes.bool

    },
    getInitialState: function getInitialState() {
        return { isHover: false };
    },
    __onMouseEnter: function __onMouseEnter() {
        this.setState({ isHover: true });
    },
    __onMouseLeave: function __onMouseLeave() {
        this.setState({ isHover: false });
    },
    render: function render() {

        if (this.props.isActive || this.state.isHover) {
            return _jsx("div", {}, void 0, _jsx("div", {
                onMouseEnter: this.__onMouseEnter,
                onMouseLeave: this.__onMouseLeave,
                className: "m-tabs_tiles--tileWrapper"
            }, void 0, _ref, _jsx("img", {
                width: this.props.imgSourceActiveWidth,
                height: this.props.imgSourceActiveHeight,
                className: "m-tabs_tiles--clickable-img",
                src: this.props.imgSourceActive
            })), _jsx("div", {
                className: "m-tabs_tiles--tile-text-container "
            }, void 0, _jsx("p", {}, void 0, this.props.imgText)));
        } else {
            return _jsx("div", {}, void 0, _jsx("div", {
                onMouseEnter: this.__onMouseEnter,
                onMouseLeave: this.__onMouseLeave,
                className: "m-tabs_tiles--tileWrapper show-for-large-up"
            }, void 0, _ref2, _jsx("img", {
                width: this.props.imgSourceInactiveWidth,
                height: this.props.imgSourceInactiveHeight,
                className: "m-tabs_tiles--clickable-img",
                src: this.props.imgSourceInactive
            })), _jsx("div", {
                className: "m-tabs_tiles--tile-text-container show-for-large-up"
            }, void 0, _jsx("p", {}, void 0, this.props.imgText)));
        }
    }

});

module.exports = ClickableImage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/tabbed-area/clickable-image.jsx
 ** module id = 802
 ** module chunks = 0
 **/